import { Link, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { AuthLayout } from "@/components/layout/AuthLayout";
import { useAuthStore } from "@/stores/authStore";

interface VerifyLocationState {
  email?: string;
}

export function VerifyEmailPendingPage() {
  const { t } = useTranslation();
  const location = useLocation();
  const user = useAuthStore((state) => state.user);
  const state = location.state as VerifyLocationState | null;
  const email = state?.email ?? user?.email ?? "your inbox";

  return (
    <AuthLayout
      eyebrow={t("auth.meta.eyebrow")}
      title={t("auth.verify.title")}
      subtitle={t("auth.verify.subtitle")}
    >
      <div className="space-y-5">
        <p className="text-base leading-7 text-ink/70">
          {t("auth.verify.body", { email })}
        </p>
        <div className="flex flex-wrap gap-3">
          <Link
            to="/login"
            className="inline-flex items-center justify-center rounded-full bg-white px-5 py-3 text-sm font-semibold text-ink shadow-sm ring-1 ring-ink/10 transition hover:bg-canvas"
          >
            {t("auth.login.submit")}
          </Link>
          <Link
            to="/register"
            className="inline-flex items-center rounded-full px-4 py-3 text-sm font-semibold text-ink/60 transition hover:text-ink"
          >
            {t("auth.register.submit")}
          </Link>
        </div>
      </div>
    </AuthLayout>
  );
}
